export const overlay = document.getElementById('theme-overlay')
export const hamburgerButton = document.getElementById('js-hamburger-button')
export const menuPrimary = document.getElementById('js-menu-primary')

export const themeButtons = document.querySelectorAll(
	'#js-theme-switcher .js-theme-option'
)

export const projectToggles = document.querySelectorAll('.js-project-toggle')
export const cards = document.querySelectorAll('.js-card')
export const teamToggles = document.querySelectorAll('.js-team-toggle')
export const teamWrapper = document.getElementById('js-team-wrapper')

export const projectDetailsWrapper = document.getElementById(
	'js-project-details'
)
export const projectDetails = document.querySelectorAll('.js-details')
